<template>
    <div>
        <div class="modal is-active" @click.stop="$emit('close')">
            <div class="modal-background" ></div>
            <div class="modal-content is-hidden-overflow">
                <img class="" :src="url"/>
            </div>
            <!--<button class="close-preview" aria-label="close" @click="$emit('close')">
                <span class="icon is-large navButton">
                    <i class="mdi mdi-48px mdi-close-circle-outline extra-large"></i>
                </span>
            </button>-->
            
        </div>
        
    </div>
</template>

<script>
export default {
    components: {
    },
    props: {
       
        url: {
            type: String,
            default: ""
        }
    },
    data: function () {
        return {};
    },
    computed: {
        
    },
    mounted: function () {
        // console.log("in mounted treasurehunt preview")
        // console.log(this.content,this.initialSlide)
    },
    methods: {
        
    },
};
</script>

<style scoped>
.modal-card-title {
    flex-shrink: 1;
}
.modal-card-body > * + * {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
.modal-content {
    width: 80%;
    height: auto;
    padding: 20px;
    animation-name: zoom;
    overflow: auto;
  animation-duration: 0.6s;
}
@keyframes zoom {
  from {transform:scale(0)}
  to {transform:scale(1)}
}
.modal-content img{
    margin: 0 auto;
}

.modal-close.is-large.big{
    height: 64px;
    max-height: 64px;
    max-width: 64px;
    min-height: 64px;
    min-width: 64px;
    width: 64px;
    right: 30px;
    top: 30px;
}



.mdi-48px.extra-large::before{
    font-size: 90px;
}
.close-preview{
    outline: none;
    border: none;
    position: absolute;
    right: 50px;
    top: 50px;
}
.limited-height{
    height: calc(100vh - 100px);
    max-height: calc(100vh -100px);
}
.modal-background{
    background-color: rgba(0,0,0,0.8);
}
</style>
